import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

export const UserProfileSkeleton: React.FC = () => {
  return (
    <div className="relative z-10 space-y-3 animate-in fade-in duration-700">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        {/* Left Column: Main Profile Card */}
        <div className="lg:col-span-2 space-y-4">
          <Card className="p-0 bg-white/70 backdrop-blur-xl border-purple-200 shadow-xl shadow-purple-500/5 rounded-3xl overflow-hidden sm:border">
            <div className="p-4 sm:p-5">
              {/* Header horizontal — avatar 64/80px ao lado do nome, não
                  mais empilhado/centralizado. */}
              <div className="flex items-center gap-3 mb-4 pb-4 border-b border-purple-100">
                <Skeleton
                  variant="rectangular"
                  width={64}
                  height={64}
                  className="rounded-2xl shrink-0"
                />
                <div className="space-y-2 flex-1">
                  <Skeleton variant="text" width={160} height={18} />
                  <Skeleton variant="text" width={200} height={12} />
                </div>
              </div>

              {/* Form Grid */}
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className={
                        i >= 3 ? "md:col-span-2 space-y-1.5" : "space-y-1.5"
                      }
                    >
                      <Skeleton variant="text" width={100} height={10} />
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={42}
                        className="rounded-xl opacity-40"
                      />
                    </div>
                  ))}

                  {/* Divider */}
                  <div className="md:col-span-2 flex items-center gap-3 py-2">
                    <div className="flex-1 h-px bg-purple-100" />
                    <Skeleton variant="text" width={140} height={10} />
                    <div className="flex-1 h-px bg-purple-100" />
                  </div>

                  {[1, 2, 3].map((i) => (
                    <div
                      key={`pwd-${i}`}
                      className={
                        i === 1 ? "md:col-span-2 space-y-1.5" : "space-y-1.5"
                      }
                    >
                      <Skeleton variant="text" width={100} height={10} />
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={42}
                        className="rounded-xl opacity-40"
                      />
                    </div>
                  ))}
                </div>

                {/* Save Button */}
                <div className="flex justify-end pt-4">
                  <Skeleton
                    variant="rectangular"
                    width={180}
                    height={40}
                    className="rounded-xl"
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          {/* Info Card — grid 2 colunas (Membro Desde/Último Acesso +
              Informações Adicionais), não mais lista vertical. */}
          <Card className="p-5 bg-white/70 backdrop-blur-xl border-purple-200 shadow-xl shadow-purple-500/5 rounded-3xl sm:border">
            <Skeleton variant="text" width="70%" height={14} className="mb-3" />
            <div className="grid grid-cols-2 gap-3 mb-4 pb-4 border-b border-purple-50">
              {[1, 2].map((i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <Skeleton
                    variant="rectangular"
                    width={28}
                    height={28}
                    className="rounded-lg shrink-0"
                  />
                  <div className="space-y-1 flex-1">
                    <Skeleton variant="text" width={50} height={8} />
                    <Skeleton variant="text" width={70} height={12} />
                  </div>
                </div>
              ))}
            </div>

            <Skeleton variant="text" width="60%" height={14} className="mb-3" />
            <div className="grid grid-cols-2 gap-3">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className={`flex items-center gap-2.5 ${i === 1 ? "col-span-2" : ""}`}
                >
                  <Skeleton
                    variant="rectangular"
                    width={28}
                    height={28}
                    className="rounded-lg shrink-0"
                  />
                  <div className="space-y-1 flex-1">
                    <Skeleton variant="text" width={50} height={8} />
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                </div>
              ))}
            </div>
          </Card>

          {/* Card combinado (Proteção & Ajuda) — era 2 cards separados,
              agora é 1 só com divisor interno. */}
          <div className="rounded-3xl bg-gray-100 p-5 space-y-4 animate-pulse">
            <div className="space-y-2">
              <Skeleton
                variant="text"
                width="60%"
                height={14}
                className="opacity-60"
              />
              <Skeleton
                variant="text"
                width="90%"
                height={10}
                className="opacity-40"
              />
              <Skeleton
                variant="text"
                width="70%"
                height={10}
                className="opacity-40"
              />
            </div>
            <div className="pt-4 border-t border-white/30 space-y-2">
              <Skeleton
                variant="text"
                width="50%"
                height={14}
                className="opacity-60"
              />
              <Skeleton
                variant="text"
                width="85%"
                height={10}
                className="opacity-40"
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={32}
                className="rounded-lg opacity-30 mt-2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileSkeleton;
